module.exports = __webpack_public_path__ + "img/icon_dashboard.eb596f1e.svg";